import axios from 'axios'
import router from '../../router/router'
import base from '../../config/base'
import qs from 'qs' // 解决post请求参数不对的问题

axios.defaults.timeout = 5000
axios.defaults.baseURL = base.baseUrl

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (navigator.onLine || window.navigator.onLine === true) {
      if (config.headers['Content-Type']) {
        return config
      }
      config.headers = {
        'Content-Type': 'application/json;'
      }
      if (config.method === 'get') {
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
        config.paramsSerializer = function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }
      return config
    } else {
      const loading = this.$loading()
      setTimeout(() => {
        loading.close()
        this.$message.error(this.$i18n.t('lang.warning_network'))
      }, 500)
    }
  }, error => {
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    console.log(response)
    if (response.data.errorCode == 2) {
      router.push({
        path: '/login',
        querry: {
          redirect: router.currentRoute.fullPath
        } // 从哪个页面跳转
      })
    }
    if (response.data && typeof response.data === 'string' && response.data.indexOf('<!DOCTYPE html>') >= 0) {
      response.data = null
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    // url = encodeURI(url) // 编码  解决IE、360兼容模式请求参数乱码问题
    // params = encodeURI(params) // 编码  解决IE、360兼容模式请求参数乱码问题
       var urls = url.split('?')[1]
      //  alert(JSON.stringify(urls))
       if (urls != '' && urls != undefined) {
        var paramArr = urls.split('&')
       for (var i = 0; i < paramArr.length; i++) {
        var str = paramArr[i].split('=')
        params[str[0]] = str[1]
      }
        // alert(JSON.stringify(params))
      }
      url = url.split('?')[0]
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: params
      })
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装post请求，contenttype使用application/json
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(data))
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装post请求，Content-Type使用application/json
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postJson(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}
/**
 * 封装post请求（formdata用）
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postFormData(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装patch请求 contenttype使用application/x-www-form-urlencoded
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patchEncode(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.patch(url, qs.stringify(data), { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' } })
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装patch请求 application/x-www-form-urlencoded
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data)
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patchFormData(url, data = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data)
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        if (response.data.errCode && response.data.errCode != 0) {
          if (response.data.errCode === 6) {
            this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
            localStorage.clear() // 清理localStorage里面的所有数据
            this.$router.push({ name: 'login' })
          } else {
            reject(response.data.errMsg)
          }
        } else {
          resolve(response.data)
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装getArr请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getArr(url, params = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.put(url,
        params, { headers: { 'Content-type': 'application/json' } })
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        }, err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}

/**
 * 封装delete方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function deleteData(url, params = {}) {
  if (navigator.onLine || window.navigator.onLine === true) {
    return new Promise((resolve, reject) => {
      axios.delete(url, {
        params: params
      })
        .then(response => {
          if (response.data.errCode && response.data.errCode != 0) {
            if (response.data.errCode === 6) {
              this.$message.error(this.$i18n.t('账号信息超时，请重新登录'))
              localStorage.clear() // 清理localStorage里面的所有数据
              this.$router.push({ name: 'login' })
            } else {
              reject(response.data.errMsg)
            }
          } else {
            resolve(response.data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  } else {
    const loading = this.$loading()
    setTimeout(() => {
      loading.close()
      this.$message.error(this.$i18n.t('lang.warning_network'))
    }, 500)
  }
}
